import React from 'react';
//import {authRoles} from '../../auth';

export const DocumentsListConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth: ['master', 'rh', 'rh_not_signer'],
    routes: [{
        path: '/documents-type-list',
        component: React.lazy(() =>
            import ('./DocumentsTypeList'))
    }]
};